import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { avatarUrl } from 'utils/Formatters';

const NotesHeader = ({ player, questionnaire }) => {
  const { t } = useTranslation();
  const bg = { backgroundImage: avatarUrl(player) };
  return (
    <div className='row u-margin-top--base u-margin-bottom--base'>
      <div className='column u-flex align-middle'>
        <div style={bg} className='o-avatar o-avatar--base u-margin-right--base'></div>
        <div>
          <b>{t('notes.allNotes')}</b><br />
          <span className='cs-txt--sp-gray'>{player.name}</span>
          <span className='o-webnote__delimeter cs-txt--sp-gray'>|</span>
          <span className='cs-txt--sp-gray'>{questionnaire.name} {questionnaire.age}</span>
        </div>
      </div>
    </div>
  );
}

NotesHeader.propTypes = {
  player: PropTypes.object.isRequired,
  questionnaire: PropTypes.object.isRequired,
}

export default NotesHeader;
